import {Button} from '@mintdata-wsp/common/components/button/Button';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Spinner, SpinnerSize, SpinnerStyle} from '@mintdata-wsp/common/components/spinner/Spinner';
import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonSize, ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {Invitor} from '@mintdata-wsp/wsp/ui/dialogs/publish/invite/Invitor';
import {Popover} from '@mintdata/mint-kit/impl/components/popover/Popover';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import * as classnames from 'classnames/bind';
import {action, computed, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./AddPeople.less');
const cx = classnames.bind(styles);

interface AddPeopleProps
{
    onInvitationsSended:() => void;
}

@observer
export class AddPeople extends React.Component<AddPeopleProps, any>
{
    @observable
    private _showPopover:boolean = false;

    private _addPeoplePopupId:string = `addPeoplePopup-${IdUtil.newGUID()}`;

    private _addPeopleRef:HTMLElement;
    private _refHandler = (el:HTMLElement) => (this._addPeopleRef = el);

    @observable
    private _emails:string[] = [];

    @computed
    private get _isInviteDisabled():boolean
    {
        return !this._emails.length;
    }

    componentDidMount()
    {
        this._initState();

        let {currentRouteProps} = rootState.navigation;

        const {location: {state}} = currentRouteProps;
        if( state && state.openAddPeopleDialog )
        {
            this._buttonAddPeople();
        }
    }

    @action.bound
    private _initState()
    {
        this._emails = [];
    }

    @action.bound
    private _buttonAddPeople()
    {
        this._showPopover = !this._showPopover;

        if( this._showPopover )
            this._initState();
    }

    @action.bound
    private _closePopover()
    {
        this._showPopover = false;
        this._initState();
    }

    @action.bound
    private _buttonInvite()
    {
        controllers.ui.members.createInvitation(this._emails)
            .then(() =>
            {
                this.sendMDAEventInviteSent();
                this._closePopover();

                const {onInvitationsSended} = this.props;

                if( onInvitationsSended && typeof onInvitationsSended == 'function' )
                    onInvitationsSended();
            })
            .catch((err) =>
            {
                console.warn(err);
            });

    }

    private sendMDAEventInviteSent()
    {
        const {currentOrganization} = rootState.userSession;

        this._emails.forEach((email:string) =>
        {
            controllers.analytics.main.trackEvent(
                AnalyticsEventActions.WSP_INVITE_SENT,
                {
                    invite_email: email,
                    org_sid: currentOrganization.siteId,
                    org_name: currentOrganization.name
                }
            );
        });
    }

    @action.bound
    private _onChangeInvitor(emails)
    {
        this._emails = emails;
    }

    private _getSpinner():JSX.Element
    {
        return <Spinner size={SpinnerSize.Medium_24} style={SpinnerStyle.White} />;
    }

    private _renderPopover()
    {
        const controller = controllers.ui.members;

        const {isInviteInProgress} = rootState.ui.members;

        return (
            <Popover
                id={this._addPeoplePopupId}
                isModal={false}
                popupSource={this._addPeopleRef}
                sourceAnchor={SourceAnchor.RightBottom}
                popupAnchor={PopupAnchor.RightTop}
                onDismissed={this._closePopover}
                className={styles.popover}
            >

                <Column className={cx('addPeopleWrapper')}>

                    <Row className={cx('title')}>
                        Add People
                    </Row>

                    <Invitor
                        className={cx('invitor')}
                        onChange={this._onChangeInvitor}
                        // validateFn={controller.validateEmail}
                    />

                    <Row className={cx('footer')}>
                        <Button
                            className={cx('buttonInvite')}
                            caption={'Invite'}
                            onClick={this._buttonInvite}
                            isDisabled={this._isInviteDisabled}
                            icon={isInviteInProgress ? this._getSpinner() : null}
                            relativeIcon={true}
                        />
                    </Row>

                </Column>

            </Popover>
        );
    }

    render()
    {
        return (
            <Column className={cx('addPeople')}>

                <div ref={this._refHandler}>
                    <WSPButton className={cx('addPeopleButton')}
                               iconClassName={cx('addPeopleButtonIcon')}
                               icon={MDIcons.common.PeopleAdd}
                               caption={'ADD PEOPLE'}
                               style={ButtonStyle.SimpleSecondary}
                               size={ButtonSize.Medium}
                               onClick={this._buttonAddPeople}
                    />
                </div>

                {this._showPopover && this._renderPopover()}

            </Column>
        );
    }
}





